export * from 'cf-core/src/images'
export const Hero404 =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582791158/general/404Hero.png'
export const appStore =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/app-store.png'
export const cftitle =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/cftitle.png'
export const googlePlay =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/google-play.png'
export const user =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/ebisu/user.png'
export const sharedBg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1582514489/general/marblebgdefault.jpg'
export const orderStatusProgress =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554602154/general/OrderStatusProgress.png'
export const orderStatusMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1554666730/general/OrderStatusMeter.png'
export const promoHeader =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/Shaolin/promoHeader.png'
export const restaurant =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1562129124/Shaolin/restaurant.jpg'
export const yelp =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/yelp_white.png'
export const facebook =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869832/general/facebook_white.png'
export const zomato =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/zomato_white.png'
export const instagram =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto/v1601869833/general/instagram_white.png'
export const contactMobilebg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/contactMobilebg.jpg'
export const rewardbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardbg.jpg'
export const downloadButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/downloadButton.png'
export const flowerTL =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerTL.png'
export const flowerBR =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/flowerBR.png'
export const redeemButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/redeemButton.png'
export const pointsMeter =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/pointsMeter.png'
export const rewardArrowLeft =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowLeft.png'
export const rewardArrowRight =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardArrowRight.png'
export const rewardDefault =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1576892025/halusushi/rewardDefault.png'
export const viewMenu =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1582589981/Kaido/viewMenu.png'
export const cflogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/f_auto,q_auto:best/v1590261442/general/cflogo.png'
export const about =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577109/sushitendo/about.jpg'
export const contactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577211/sushitendo/contactbg.webp'
export const foodGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690591744/sushitendo/foodGallery.webp'
export const hero =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577211/sushitendo/hero.webp'
export const heroText =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577405/sushitendo/heroText.webp'
export const logo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577404/sushitendo/logo.webp'
export const locationMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577289/sushitendo/locationMap.webp'
export const mobileAbout =
  'https://d3vh3ipdcbqfrq.cloudfront.net/mobileAbout.webp'
export const mobileContactbg =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690579517/sushitendo/mobileContact.webp'
export const mobileGallery =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690591742/sushitendo/mobileGallery.webp'
export const mobileHero =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690601995/sushitendo/monileHero.webp'
export const mobileMap =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690579517/sushitendo/mobileMap.webp'
export const mobileHeroText =
  'https://d3vh3ipdcbqfrq.cloudfront.net/mobileText.png'
export const mobilePromotion =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690579517/sushitendo/mobilePromo.webp'
export const orderPickupButton =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577405/sushitendo/orderPickupButton.webp'
export const promotions =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690577211/sushitendo/promo.webp'
export const mobileLogo =
  'https://res.cloudinary.com/codefusiontech/image/upload/v1690579517/sushitendo/mobileLogo.webp'
